import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from './scenes/GameIntro';

interface PhaserCityBuilderGameProps {
    onComplete: () => void;
}

interface PhaserCityBuilderGameState {
}

const gameConfig: GameConfig = {
    title: "City Builder Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserCityBuilderGame extends React.Component<PhaserCityBuilderGameProps, PhaserCityBuilderGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserCityBuilderGameProps) {
        super(props);
        bindAllOfThis(this, PhaserCityBuilderGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserCityBuilderGame;



// WEBPACK FOOTER //
// ./src/games/CityBuilderGame/Main.tsx